import { Directive, ElementRef, OnInit, OnDestroy, Renderer2, inject, output } from '@angular/core';
import { closest, hasClass, isChildOf } from '@app/shared/utilities/javascript-utilities';

@Directive({
    selector: '[appGridRClick]',
})
export class GridRClickDirective implements OnInit, OnDestroy {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  readonly openMenu = output<HTMLTableRowElement>();
  readonly closeMenu = output<any>();

  private listeners: Array<() => void> = [];

  // disable the page context menu using this
  //       <body oncontextmenu='return false'>

  public ngOnInit(): void {
    this.listeners.push(this.renderer.listen(
      this.el.nativeElement,
      'contextmenu',
      ({ target }) => {
        const tr = closest(target, 'tr');
        if (tr && !hasClass(tr, 'k-grid-edit-row') && isChildOf(target, 'k-grid-content')) {
          this.openMenu.emit(tr as HTMLTableRowElement);
        }
      }
    ));

    this.listeners.push(this.renderer.listen(
      'document',
      'click',
      ({ target }) => {
        if (!isChildOf(target, 'k-grid-content') && !isChildOf(target, 'k-grid-toolbar')) {
          this.closeMenu.emit(null);
        }
      }));
  }

  public ngOnDestroy(): void {
    this.listeners.forEach(unlisten => unlisten());
    this.listeners = [];
  }
}